import Language from "@mui/icons-material/Language";
import OpenInNewIcon from "@mui/icons-material/OpenInNew";
import SwitchAccessShortcutAddIcon from "@mui/icons-material/SwitchAccessShortcutAdd";
import { Button } from "@mui/material";
import type { FC } from "react";

export const CreateContentLinks: FC = () => {
  return (
    <>
      <Button
        href="/discover"
        data-analytics-id="create-content-newsletter"
        size="small"
        variant="text"
        startIcon={<Language />}
      >
        Discover Library
      </Button>
      <Button
        href="https://peoplecontent.com/agent"
        target="_blank"
        data-analytics-id="create-content-blueprint-ai"
        size="small"
        variant="text"
        startIcon={<SwitchAccessShortcutAddIcon />}
        endIcon={<OpenInNewIcon />}
      >
        Blueprint AI
      </Button>
    </>
  );
};
